import {modalCommentLink} from "./hoc/modalCommentLink";

const WaybillV2ResponsiblePersonReturn = modalCommentLink("WaybillV2ResponsiblePersonReturn")

export default WaybillV2ResponsiblePersonReturn
